<template>
  <div class="timeline-layout">
    <Header :key="updateKey" v-if="windowWidth >= 1024" />
    <PageTitle
      :pageTitle="this.$store.state.main.selected_menu.teaser"
      :titleColor="getColors[0]"
      :bgColor="getColors[1]"
      v-if="windowWidth >= 1024"
    />
    <div
      class="dummy-pic"
      v-if="$store.state.main.zoomedCall"
      @click="addCloseClass($event)"
    >
    <div class="cl__wrapper">
     <svg xmlns="http://www.w3.org/2000/svg" width="26.832" height="25.587" viewBox="0 0 26.832 25.587">
  <g id="Group_2154" data-name="Group 2154" transform="translate(-1415.612 195.16) rotate(-45)">
    <path id="Path_219" data-name="Path 219" d="M1.229,4.171c5.559.09,11.017-.994,16.562-1.118,3.391-.076,7.083.383,10.4-.593.824-.243,1.837-.708,1.806-1.67l0-.117c-.03-.931-1.808-.894-3.048-.3-3.016.678-6.44.081-9.477.244C12.577.881,7.737,1.764,2.831,1.685,1.142,1.658-1.63,4.125,1.229,4.171Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1154.236, 884.626)" fill="#fff" stroke="#fff" stroke-width="1"/>
    <path id="Path_3800" data-name="Path 3800" d="M1.237,4.173C6.8,4.273,12.253,3.2,17.8,3.086c3.392-.069,7.085.4,10.4-.574.824-.241,1.836-.7,1.8-1.666l0-.117c-.032-.931-1.81-.9-3.049-.3-3.015.673-6.441.069-9.478.226C12.58.9,7.741,1.779,2.835,1.69,1.146,1.66-1.623,4.121,1.237,4.173Z" transform="translate(1141.514 866.523) rotate(90)" fill="#fff" stroke="#fff" stroke-width="1"/>
  </g>
</svg>
 <span class="cl__text f-30 regular white">{{$fn.tr('დახურვა')}}</span>
    </div>
      <img src="@/assets/img/shmaxizoom.png" class="z__bg" />

      <div class="green-overlay"></div>
      <img
        :src="zoomedPic.src"
        class="z__img"
        :style="{
          left: zoomedPic.left + 'px',
          top: zoomedPic.top + 'px',
          width: zoomedPic.width + 'px',
          height: zoomedPic.height + 'px'
        }"
        alt=""
      />
    </div>
    <SmoothScrollTimeline>
      <Header :key="updateKey2" v-if="windowWidth <= 1023" />
      <PageTitle
        :pageTitle="this.$store.state.main.selected_menu.teaser"
        :titleColor="getColors[0]"
        :bgColor="getColors[1]"
        v-if="windowWidth <= 1023"
      />

      <router-view :key="updateKey"></router-view>
      <div class="timeline__footer" v-if="windowWidth <= 1023">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="255"
          height="49.7"
          viewBox="0 0 255 49.7"
        >
          <g
            id="Group_3508"
            data-name="Group 3508"
            transform="translate(-151.635 -280.655)"
          >
            <g
              id="Group_127"
              data-name="Group 127"
              transform="translate(151.635 280.655)"
            >
              <rect
                id="Rectangle_509"
                data-name="Rectangle 509"
                width="2.544"
                height="31.749"
                transform="translate(5.101)"
                fill="#fff"
              />
              <rect
                id="Rectangle_510"
                data-name="Rectangle 510"
                width="2.544"
                height="31.749"
                fill="#fff"
              />
              <rect
                id="Rectangle_511"
                data-name="Rectangle 511"
                width="5.103"
                height="31.749"
                transform="translate(10.195)"
                fill="#fff"
              />
              <rect
                id="Rectangle_512"
                data-name="Rectangle 512"
                width="7.653"
                height="31.749"
                transform="translate(17.85)"
                fill="#fff"
              />
              <rect
                id="Rectangle_513"
                data-name="Rectangle 513"
                width="2.547"
                height="31.749"
                transform="translate(35.703)"
                fill="#fff"
              />
              <rect
                id="Rectangle_514"
                data-name="Rectangle 514"
                width="2.547"
                height="31.749"
                transform="translate(40.809)"
                fill="#fff"
              />
              <rect
                id="Rectangle_515"
                data-name="Rectangle 515"
                width="5.105"
                height="31.749"
                transform="translate(51.004)"
                fill="#fff"
              />
              <rect
                id="Rectangle_516"
                data-name="Rectangle 516"
                width="2.549"
                height="31.749"
                transform="translate(58.657)"
                fill="#fff"
              />
              <rect
                id="Rectangle_517"
                data-name="Rectangle 517"
                width="5.104"
                height="31.749"
                transform="translate(68.856)"
                fill="#fff"
              />
              <rect
                id="Rectangle_518"
                data-name="Rectangle 518"
                width="2.547"
                height="31.749"
                transform="translate(94.362)"
                fill="#fff"
              />
              <rect
                id="Rectangle_519"
                data-name="Rectangle 519"
                width="2.547"
                height="31.749"
                transform="translate(89.261)"
                fill="#fff"
              />
              <rect
                id="Rectangle_520"
                data-name="Rectangle 520"
                width="2.546"
                height="31.749"
                transform="translate(76.508)"
                fill="#fff"
              />
              <rect
                id="Rectangle_521"
                data-name="Rectangle 521"
                width="7.651"
                height="31.749"
                transform="translate(99.463)"
                fill="#fff"
              />
              <rect
                id="Rectangle_522"
                data-name="Rectangle 522"
                width="2.55"
                height="31.749"
                transform="translate(122.415)"
                fill="#fff"
              />
              <rect
                id="Rectangle_523"
                data-name="Rectangle 523"
                width="2.546"
                height="31.749"
                transform="translate(117.316)"
                fill="#fff"
              />
              <rect
                id="Rectangle_524"
                data-name="Rectangle 524"
                width="2.552"
                height="31.749"
                transform="translate(82.346)"
                fill="#fff"
              />
              <rect
                id="Rectangle_525"
                data-name="Rectangle 525"
                width="2.542"
                height="31.749"
                transform="translate(186.972)"
                fill="#fff"
              />
              <rect
                id="Rectangle_526"
                data-name="Rectangle 526"
                width="2.547"
                height="31.749"
                transform="translate(112.215)"
                fill="#fff"
              />
              <rect
                id="Rectangle_527"
                data-name="Rectangle 527"
                width="7.641"
                height="31.749"
                transform="translate(127.518)"
                fill="#fff"
              />
              <rect
                id="Rectangle_528"
                data-name="Rectangle 528"
                width="2.547"
                height="31.749"
                transform="translate(140.265)"
                fill="#fff"
              />
              <rect
                id="Rectangle_529"
                data-name="Rectangle 529"
                width="5.097"
                height="31.749"
                transform="translate(155.566)"
                fill="#fff"
              />
              <rect
                id="Rectangle_530"
                data-name="Rectangle 530"
                width="5.101"
                height="31.749"
                transform="translate(145.366)"
                fill="#fff"
              />
              <rect
                id="Rectangle_531"
                data-name="Rectangle 531"
                width="2.544"
                height="31.749"
                transform="translate(163.222)"
                fill="#fff"
              />
              <rect
                id="Rectangle_532"
                data-name="Rectangle 532"
                width="7.649"
                height="31.749"
                transform="translate(168.325)"
                fill="#fff"
              />
              <rect
                id="Rectangle_533"
                data-name="Rectangle 533"
                width="2.552"
                height="31.749"
                transform="translate(181.074)"
                fill="#fff"
              />
              <rect
                id="Rectangle_534"
                data-name="Rectangle 534"
                width="2.547"
                height="31.749"
                transform="translate(193.828)"
                fill="#fff"
              />
              <rect
                id="Rectangle_535"
                data-name="Rectangle 535"
                width="5.101"
                height="31.749"
                transform="translate(226.978)"
                fill="#fff"
              />
              <rect
                id="Rectangle_536"
                data-name="Rectangle 536"
                width="5.104"
                height="31.749"
                transform="translate(206.571)"
                fill="#fff"
              />
              <rect
                id="Rectangle_537"
                data-name="Rectangle 537"
                width="5.103"
                height="31.749"
                transform="translate(216.778)"
                fill="#fff"
              />
              <rect
                id="Rectangle_538"
                data-name="Rectangle 538"
                width="5.1"
                height="31.749"
                transform="translate(198.924)"
                fill="#fff"
              />
              <rect
                id="Rectangle_539"
                data-name="Rectangle 539"
                width="2.544"
                height="31.749"
                transform="translate(234.633)"
                fill="#fff"
              />
              <rect
                id="Rectangle_540"
                data-name="Rectangle 540"
                width="2.547"
                height="31.749"
                transform="translate(239.732)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_128"
              data-name="Group 128"
              transform="translate(151.957 316.63)"
            >
              <path
                id="Path_441"
                data-name="Path 441"
                d="M155,340.693a1.973,1.973,0,0,0,1.635.751,2.08,2.08,0,0,0,1.664-.8,2.655,2.655,0,0,0,.627-1.765,4.425,4.425,0,0,0-.047-.792,2.1,2.1,0,0,0-.8-1.247,2.185,2.185,0,0,0-1.362-.468,1.958,1.958,0,0,0-1.2.392,2.1,2.1,0,0,0-1.243-.392,2.163,2.163,0,0,0-1.521.593,2.049,2.049,0,0,0-.683,1.589v.387a3.525,3.525,0,0,0,.875,2.365h-.572l-.009.882h.441q3.556.022,4.838,2.754l.186.4.8-.378a6.169,6.169,0,0,0-3.67-3.386,2.631,2.631,0,0,1-2.014-2.642v-.387a1.294,1.294,0,0,1,1.3-1.295,1.207,1.207,0,0,1,.659.171,2.909,2.909,0,0,0-.447,1.6A2.576,2.576,0,0,0,155,340.693Zm.46-2.389a2.441,2.441,0,0,1,.5-.773,1.185,1.185,0,0,1,.783-.275,1.365,1.365,0,0,1,.868.3,1.1,1.1,0,0,1,.426.794c.007.11.012.222.012.333q0,1.879-1.415,1.877a1.27,1.27,0,0,1-.921-.376,1.216,1.216,0,0,1-.374-.913A3.016,3.016,0,0,1,155.464,338.3Z"
                transform="translate(-152.076 -331.633)"
                fill="#fff"
              />
              <path
                id="Path_442"
                data-name="Path 442"
                d="M170.29,336.092a1.287,1.287,0,0,1-.769-.559,3.334,3.334,0,0,1-.321-.9l-.854.215.1.428a2.078,2.078,0,0,0,.927,1.3l1.2.661a1.365,1.365,0,0,1,.594,1.192,1.4,1.4,0,0,1-.6,1.213,2.2,2.2,0,0,1-1.313.38,2.224,2.224,0,0,1-1.312-.373,1.409,1.409,0,0,1-.6-1.22,1.475,1.475,0,0,1,.21-.771l.217-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.234,2.234,0,0,0,.862,1.846,3.267,3.267,0,0,0,3.855,0,2.241,2.241,0,0,0,.859-1.846,2.383,2.383,0,0,0-.494-1.472A2.349,2.349,0,0,0,170.29,336.092Z"
                transform="translate(-155.952 -331.165)"
                fill="#fff"
              />
              <path
                id="Path_443"
                data-name="Path 443"
                d="M182.781,330.743a2.915,2.915,0,0,0-1.937.661,2.308,2.308,0,0,0-.856,1.867,3.644,3.644,0,0,0,.43,1.456l.791-.373a2.875,2.875,0,0,1-.347-1.083,1.473,1.473,0,0,1,.6-1.239,2.1,2.1,0,0,1,1.318-.408,2.077,2.077,0,0,1,1.308.4,1.458,1.458,0,0,1,.6,1.241v2.2a2.281,2.281,0,0,0-1.614-.6,2.5,2.5,0,1,0,2.489,2.5v-4.1a2.3,2.3,0,0,0-.853-1.867A2.923,2.923,0,0,0,182.781,330.743Zm1.432,7.763a1.613,1.613,0,1,1,.007-2.284,1.636,1.636,0,0,1-.007,2.284Z"
                transform="translate(-159.591 -330.117)"
                fill="#fff"
              />
              <path
                id="Path_444"
                data-name="Path 444"
                d="M197.541,335.07l1.269-.957-.531-.7-2.183,1.648a5.482,5.482,0,0,0,.468-1.86,6.086,6.086,0,0,0,0-.615,1.841,1.841,0,0,0-.56-1.3,1.777,1.777,0,0,0-1.3-.538,1.7,1.7,0,0,0-1.413.675,2.535,2.535,0,0,0,0,2.943,1.706,1.706,0,0,0,1.413.668,1.848,1.848,0,0,0,.551-.083q-.443,1.117-.468,1.212a3.924,3.924,0,0,0-.241,1.276,2.428,2.428,0,0,0,4.856,0,2.437,2.437,0,0,0-1.86-2.365Zm-2.833-.922a.9.9,0,0,1-.761-.391,1.452,1.452,0,0,1-.251-.862,1.409,1.409,0,0,1,.258-.867.866.866,0,0,1,.755-.4.949.949,0,0,1,.7.291.908.908,0,0,1,.284.694,8.02,8.02,0,0,1-.013.876A1.176,1.176,0,0,1,194.708,334.148Zm3.362,4.379a1.555,1.555,0,0,1-2.193,0,1.467,1.467,0,0,1-.454-1.092,1.562,1.562,0,0,1,1.548-1.55,1.553,1.553,0,0,1,1.555,1.55A1.472,1.472,0,0,1,198.07,338.526Z"
                transform="translate(-163.046 -330.117)"
                fill="#fff"
              />
              <path
                id="Path_445"
                data-name="Path 445"
                d="M210.849,336.092a1.283,1.283,0,0,1-.77-.559,3.336,3.336,0,0,1-.321-.9l-.854.215.1.428a2.083,2.083,0,0,0,.924,1.3c.4.221.8.44,1.2.661a1.361,1.361,0,0,1,.6,1.192,1.4,1.4,0,0,1-.6,1.213,2.189,2.189,0,0,1-1.313.38,2.224,2.224,0,0,1-1.312-.373,1.412,1.412,0,0,1-.6-1.22,1.484,1.484,0,0,1,.211-.771l.217-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.23,2.23,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.245,2.245,0,0,0,.856-1.846,2.371,2.371,0,0,0-.5-1.472A2.338,2.338,0,0,0,210.849,336.092Z"
                transform="translate(-166.872 -331.165)"
                fill="#fff"
              />
              <path
                id="Path_446"
                data-name="Path 446"
                d="M222.6,340.693a1.974,1.974,0,0,0,1.632.751,2.086,2.086,0,0,0,1.669-.8,2.689,2.689,0,0,0,.626-1.765,4.3,4.3,0,0,0-.049-.792,2.088,2.088,0,0,0-.8-1.247,2.193,2.193,0,0,0-1.364-.468,1.958,1.958,0,0,0-1.2.392,2.1,2.1,0,0,0-1.241-.392,2.166,2.166,0,0,0-1.523.593,2.054,2.054,0,0,0-.683,1.589v.387a3.493,3.493,0,0,0,.876,2.365h-.571l-.012.882h.445q3.555.022,4.835,2.754l.186.4.8-.378a6.158,6.158,0,0,0-3.669-3.386,2.632,2.632,0,0,1-2.014-2.642v-.387a1.3,1.3,0,0,1,1.3-1.295,1.222,1.222,0,0,1,.664.171,2.893,2.893,0,0,0-.45,1.6A2.573,2.573,0,0,0,222.6,340.693Zm.456-2.389a2.58,2.58,0,0,1,.5-.773,1.184,1.184,0,0,1,.783-.275,1.37,1.37,0,0,1,.869.3,1.1,1.1,0,0,1,.425.794c.007.11.015.222.015.333q0,1.879-1.421,1.877a1.258,1.258,0,0,1-.915-.376,1.2,1.2,0,0,1-.379-.913A3.127,3.127,0,0,1,223.058,338.3Z"
                transform="translate(-170.276 -331.633)"
                fill="#fff"
              />
              <path
                id="Path_447"
                data-name="Path 447"
                d="M238.886,336.865a2.9,2.9,0,0,0-1.719-.483,3.836,3.836,0,0,0-.882.089,2.076,2.076,0,0,0-1.211.777,2.139,2.139,0,0,0-.449,1.311,1.972,1.972,0,0,0,.394,1.206l.968-.151a2.341,2.341,0,0,1-.476-1.206.942.942,0,0,1,.569-.894,2.283,2.283,0,0,1,1.09-.249c1.076,0,1.618.4,1.618,1.2v4.175q0,1.679-1.916,1.681a2.24,2.24,0,0,1-1.369-.384,1.515,1.515,0,0,1-.594-1.3,2.16,2.16,0,0,1,.908-1.7h-1.025a4.216,4.216,0,0,0-.539.628,2.178,2.178,0,0,0-.217,1.073,2.348,2.348,0,0,0,.85,1.923,3.036,3.036,0,0,0,1.986.64,2.947,2.947,0,0,0,1.962-.633,2.39,2.39,0,0,0,.829-1.931v-4.175A1.837,1.837,0,0,0,238.886,336.865Z"
                transform="translate(-174.144 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_448"
                data-name="Path 448"
                d="M251.9,335.518a1.644,1.644,0,0,1-.573-.826,1.847,1.847,0,0,1-.06-.409v-1.206a1.31,1.31,0,0,0-1.306-1.3h-.436a.376.376,0,0,1-.431-.422h-.875a8.42,8.42,0,0,1-.275,2.194l-.11.425.855.221a12.535,12.535,0,0,0,.342-1.634,1.276,1.276,0,0,0,.5.1h.436a.368.368,0,0,1,.417.419c0,.82,0,1.248.009,1.29q-.9.659-1.793,1.322a2.388,2.388,0,0,0-.955,1.9,2.2,2.2,0,0,0,.853,1.825,3.226,3.226,0,0,0,3.8-.007,2.21,2.21,0,0,0,.852-1.818,2.039,2.039,0,0,0-.424-1.309A7.789,7.789,0,0,0,251.9,335.518Zm-.216,3.259a2.443,2.443,0,0,1-2.573,0,1.375,1.375,0,0,1-.6-1.192,1.445,1.445,0,0,1,.756-1.309,11.8,11.8,0,0,0,1.353-.959,5.159,5.159,0,0,0,1.01,1.048,1.609,1.609,0,0,1,.636,1.22A1.386,1.386,0,0,1,251.68,338.777Z"
                transform="translate(-177.807 -330.282)"
                fill="#fff"
              />
              <path
                id="Path_449"
                data-name="Path 449"
                d="M265.449,336.318a1.584,1.584,0,0,0-1.073.406,1.249,1.249,0,0,0-1.8-.042,1.216,1.216,0,0,0-.372.878c-.007.568-.179.854-.524.854a.506.506,0,0,1-.419-.221.656.656,0,0,1,.116-.966c.058-.049.223-.167.5-.349l-.493-.731a4.369,4.369,0,0,0-.8.643,1.426,1.426,0,0,0-.359.95,1.61,1.61,0,0,0,.417,1.09,1.388,1.388,0,0,0,2.021.056,1.371,1.371,0,0,0,.414-.983,1.967,1.967,0,0,1,.033-.452.366.366,0,0,1,.712.116v2.328h.875v-2.018a.7.7,0,0,1,.247-.482.764.764,0,0,1,1.276.563v4.617q0,1.68-1.918,1.681a2.249,2.249,0,0,1-1.367-.384,1.519,1.519,0,0,1-.6-1.3,1.491,1.491,0,0,1,.279-.9,3.668,3.668,0,0,1,.677-.656l-.55-.69a4.4,4.4,0,0,0-.922.964,2.322,2.322,0,0,0-.358,1.283,2.349,2.349,0,0,0,.852,1.923,3.035,3.035,0,0,0,1.984.64,2.954,2.954,0,0,0,1.966-.633,2.389,2.389,0,0,0,.827-1.931v-4.617a1.638,1.638,0,0,0-1.643-1.639Z"
                transform="translate(-181.195 -331.572)"
                fill="#fff"
              />
              <path
                id="Path_450"
                data-name="Path 450"
                d="M278.937,340.937h1.033a5.423,5.423,0,0,0,.482-.957,4.37,4.37,0,0,0,.159-1.311q0-2.284-1.49-2.286a1.2,1.2,0,0,0-.936.391,1.442,1.442,0,0,0-1.006-.391,1.475,1.475,0,0,0-1.02.391,1.177,1.177,0,0,0-.931-.391q-1.489,0-1.488,2.3a4.357,4.357,0,0,0,1.29,3.155c-.479.077-.836.144-1.076.2l.193.859a7.159,7.159,0,0,1,1.418-.2,5.127,5.127,0,0,1,1.138.13,4.78,4.78,0,0,1,3,2.542l.767-.433a6.389,6.389,0,0,0-1.542-1.871,7.308,7.308,0,0,0-2.3-1.155,2.7,2.7,0,0,1-1.353-1.158,3.63,3.63,0,0,1-.662-2.065c0-.943.2-1.413.611-1.413q.465,0,.466.447v2.247h.875v-2.24a.381.381,0,0,1,.191-.323.752.752,0,0,1,.427-.131.73.73,0,0,1,.417.133.4.4,0,0,1,.191.328v2.233h.875v-2.24a.4.4,0,0,1,.458-.454c.4,0,.61.468.61,1.4a3.534,3.534,0,0,1-.669,2.088Z"
                transform="translate(-184.835 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_451"
                data-name="Path 451"
                d="M290.939,336.383a2.673,2.673,0,0,0-1.9.754,2.773,2.773,0,0,0-.88,1.858,3.93,3.93,0,0,0,.828,2.211l.268.35.7-.546a3.811,3.811,0,0,1-.918-2.01,1.867,1.867,0,0,1,.617-1.238A1.91,1.91,0,0,1,292.839,339a3.81,3.81,0,0,1-.913,2.01l.694.546A4.683,4.683,0,0,0,293.714,339a2.759,2.759,0,0,0-.875-1.858A2.672,2.672,0,0,0,290.939,336.383Z"
                transform="translate(-188.716 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_452"
                data-name="Path 452"
                d="M305.485,336.092a1.26,1.26,0,0,1-.766-.559,3.22,3.22,0,0,1-.324-.9l-.855.215.106.428a2.07,2.07,0,0,0,.927,1.3c.4.221.8.44,1.2.661a1.357,1.357,0,0,1,.592,1.192,1.4,1.4,0,0,1-.592,1.213,2.2,2.2,0,0,1-1.313.38,2.238,2.238,0,0,1-1.315-.373,1.41,1.41,0,0,1-.6-1.22,1.524,1.524,0,0,1,.209-.771l.22-.387-.757-.433a3.336,3.336,0,0,0-.547,1.59,2.228,2.228,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.243,2.243,0,0,0,.852-1.846,2.428,2.428,0,0,0-1.753-2.342Z"
                transform="translate(-192.354 -331.165)"
                fill="#fff"
              />
              <path
                id="Path_453"
                data-name="Path 453"
                d="M333.189,335.4c-.252-.193-.379-.344-.379-.456a.252.252,0,0,1,.286-.282h.445v-.882h-.44a1.113,1.113,0,0,0-.825.342,1.138,1.138,0,0,0,.041,1.665c.224.2.458.4.693.6a1.4,1.4,0,0,1,.373.995,1.419,1.419,0,0,1-.587,1.21,2.077,2.077,0,0,1-1.288.394,2.031,2.031,0,0,1-1.291-.4,1.428,1.428,0,0,1-.59-1.213v-6.621h-.875v6.621a2.294,2.294,0,0,0,.848,1.85,3.151,3.151,0,0,0,3.819,0,2.28,2.28,0,0,0,.84-1.844,2.245,2.245,0,0,0-.373-1.3A3.715,3.715,0,0,0,333.189,335.4Z"
                transform="translate(-199.646 -330.117)"
                fill="#fff"
              />
              <path
                id="Path_454"
                data-name="Path 454"
                d="M346.042,336.092a1.278,1.278,0,0,1-.767-.559,3.336,3.336,0,0,1-.321-.9l-.854.215.1.428a2.09,2.09,0,0,0,.927,1.3l1.2.661a1.364,1.364,0,0,1,.594,1.192,1.4,1.4,0,0,1-.6,1.213,2.2,2.2,0,0,1-1.312.38,2.223,2.223,0,0,1-1.313-.373,1.409,1.409,0,0,1-.6-1.22,1.509,1.509,0,0,1,.208-.771l.218-.387-.756-.433a3.337,3.337,0,0,0-.545,1.59,2.228,2.228,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.247,2.247,0,0,0,.856-1.846,2.438,2.438,0,0,0-1.76-2.342Z"
                transform="translate(-203.274 -331.165)"
                fill="#fff"
              />
              <path
                id="Path_455"
                data-name="Path 455"
                d="M358.938,331.514l-.433.074.141.869a5.343,5.343,0,0,0,1.842-.594v3.453h-2.049a1.614,1.614,0,0,0-1.623,1.616,1.525,1.525,0,0,0,.71,1.334l.36.247.5-.726c-.267-.181-.421-.294-.476-.34a.7.7,0,0,1-.225-.512.721.721,0,0,1,.219-.522.7.7,0,0,1,.519-.214h2.063v4.67a1.477,1.477,0,0,1-.622,1.269,2.567,2.567,0,0,1-2.731,0,1.48,1.48,0,0,1-.631-1.269,1.451,1.451,0,0,1,.275-.881,3.749,3.749,0,0,1,.664-.647l-.56-.684a4.418,4.418,0,0,0-.9.946,2.451,2.451,0,0,0,.538,3.161,3.351,3.351,0,0,0,3.96,0,2.288,2.288,0,0,0,.883-1.888V329.886c-.56.566-.918.905-1.071,1.027A3.06,3.06,0,0,1,358.938,331.514Z"
                transform="translate(-206.883 -329.886)"
                fill="#fff"
              />
              <path
                id="Path_456"
                data-name="Path 456"
                d="M373.079,336.092a1.27,1.27,0,0,1-.764-.559,3.316,3.316,0,0,1-.324-.9l-.854.215.105.428a2.068,2.068,0,0,0,.929,1.3l1.2.661a1.366,1.366,0,0,1,.6,1.192,1.407,1.407,0,0,1-.6,1.213,2.189,2.189,0,0,1-1.313.38,2.248,2.248,0,0,1-1.317-.373,1.407,1.407,0,0,1-.6-1.22,1.517,1.517,0,0,1,.21-.771l.221-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.234,2.234,0,0,0,.862,1.846,3.274,3.274,0,0,0,3.86,0,2.242,2.242,0,0,0,.85-1.846,2.388,2.388,0,0,0-.49-1.472A2.346,2.346,0,0,0,373.079,336.092Z"
                transform="translate(-210.554 -331.165)"
                fill="#fff"
              />
              <path
                id="Path_457"
                data-name="Path 457"
                d="M386.739,334.866a1.811,1.811,0,0,0-1.4.615,1.734,1.734,0,0,0-1.378-.615h-.015a3.036,3.036,0,0,1,1.407-.723,2.967,2.967,0,0,0,1.683-1.057,2.936,2.936,0,0,0,.666-1.893v-.44h-.876v.443a2.1,2.1,0,0,1-1.261,1.887q-1.167.628-2.333,1.262a3.657,3.657,0,0,0-1.262,3.027,4.113,4.113,0,0,0,.813,2.3l.248.363.731-.5a4.187,4.187,0,0,1-.917-2.172q0-1.624,1.108-1.623a1.234,1.234,0,0,1,.675.175.545.545,0,0,1,.278.473v2.143h.875v-2.075a.6.6,0,0,1,.31-.55,1.2,1.2,0,0,1,.649-.165q1.114,0,1.114,1.618a4.248,4.248,0,0,1-.916,2.179l.729.494a5.025,5.025,0,0,0,1.062-2.673,2.973,2.973,0,0,0-.454-1.7A1.727,1.727,0,0,0,386.739,334.866Z"
                transform="translate(-213.976 -330.119)"
                fill="#fff"
              />
              <path
                id="Path_458"
                data-name="Path 458"
                d="M400.329,336.354a1.6,1.6,0,0,0-1.193.5,2.075,2.075,0,0,0-1.376-.5,2.038,2.038,0,0,0-1.5.624,2.134,2.134,0,0,0-.647,1.511c-.007.363-.007.615,0,.752.015.207.037.36.051.463h0a2.161,2.161,0,0,0,2.1,1.667,2.043,2.043,0,0,0,1.513-.634,2.13,2.13,0,0,0,.638-1.51,3.842,3.842,0,0,0-.228-1.633.767.767,0,0,1,.65-.358.841.841,0,0,1,.775.6,2.48,2.48,0,0,1,.207,1.027,2.378,2.378,0,0,1-.284,1.16,4.794,4.794,0,0,1-.734.921l.632.615a5.312,5.312,0,0,0,.918-1.215,3.2,3.2,0,0,0,.344-1.48,3.091,3.091,0,0,0-.437-1.668A1.584,1.584,0,0,0,400.329,336.354Zm-1.293,2.862a1.24,1.24,0,0,1-.384.9,1.222,1.222,0,0,1-.892.373,1.238,1.238,0,0,1-.8-.284,1.27,1.27,0,0,1-.449-.707c-.016-.2-.023-.31-.023-.338v-.635a1.268,1.268,0,0,1,.376-.906,1.209,1.209,0,0,1,.9-.381,1.31,1.31,0,0,1,1.06.577,1.85,1.85,0,0,1,.216.675C399.044,338.554,399.044,338.8,399.036,339.216Z"
                transform="translate(-217.647 -331.628)"
                fill="#fff"
              />
              <path
                id="Path_459"
                data-name="Path 459"
                d="M413.741,336.438a4.843,4.843,0,0,0-.826-.056,3.86,3.86,0,0,0-.881.088,2.23,2.23,0,0,0-1.178.718,1.756,1.756,0,0,0-.475,1.248,2.36,2.36,0,0,0,.389,1.329l.971-.151a2.282,2.282,0,0,1-.484-1.206.941.941,0,0,1,.569-.894,2.28,2.28,0,0,1,1.09-.249q1.613,0,1.616,1.2v.177a1.214,1.214,0,0,1-1.185,1.187h-.865v.867h1a.917.917,0,0,1,.734.356,1.285,1.285,0,0,1,.314.831,3.543,3.543,0,0,1-.3,1.784,1.746,1.746,0,0,1-1.609.654,2.231,2.231,0,0,1-1.369-.384,1.512,1.512,0,0,1-.6-1.3,1.576,1.576,0,0,1,.622-1.283l.338-.275-1.123-.144c-.153.2-.3.394-.447.586a2.181,2.181,0,0,0-.265,1.116,2.339,2.339,0,0,0,.857,1.923,3.018,3.018,0,0,0,1.982.64,2.97,2.97,0,0,0,1.969-.64,2.347,2.347,0,0,0,.819-1.923v-.757a2,2,0,0,0-.807-1.627,1.843,1.843,0,0,0,.807-1.614v-.177a2.062,2.062,0,0,0-1.667-2.026Z"
                transform="translate(-221.464 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_460"
                data-name="Path 460"
                d="M428.155,336.865a2.881,2.881,0,0,0-1.716-.483,3.816,3.816,0,0,0-.883.089,2.053,2.053,0,0,0-1.208.777,2.111,2.111,0,0,0-.453,1.311,1.973,1.973,0,0,0,.395,1.206l.973-.151a2.276,2.276,0,0,1-.48-1.206.942.942,0,0,1,.569-.894,2.269,2.269,0,0,1,1.092-.249c1.075,0,1.616.4,1.616,1.2v4.175q0,1.679-1.916,1.681a2.239,2.239,0,0,1-1.369-.384,1.509,1.509,0,0,1-.594-1.3,2.158,2.158,0,0,1,.908-1.7h-1.027a4.522,4.522,0,0,0-.539.628,2.2,2.2,0,0,0-.217,1.073,2.356,2.356,0,0,0,.849,1.923,3.047,3.047,0,0,0,1.989.64,2.947,2.947,0,0,0,1.962-.633,2.392,2.392,0,0,0,.829-1.931v-4.175A1.836,1.836,0,0,0,428.155,336.865Z"
                transform="translate(-225.105 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_461"
                data-name="Path 461"
                d="M441.169,340.937H442.2a5.636,5.636,0,0,0,.482-.957,4.44,4.44,0,0,0,.159-1.311q0-2.284-1.49-2.286a1.193,1.193,0,0,0-.934.391,1.451,1.451,0,0,0-1.008-.391,1.478,1.478,0,0,0-1.019.391,1.183,1.183,0,0,0-.932-.391q-1.489,0-1.487,2.3a4.375,4.375,0,0,0,1.287,3.155c-.479.077-.833.144-1.073.2l.192.859a7.182,7.182,0,0,1,1.421-.2,5.158,5.158,0,0,1,1.136.13,4.782,4.782,0,0,1,3,2.542l.764-.433a6.371,6.371,0,0,0-1.539-1.871,7.319,7.319,0,0,0-2.3-1.155,2.692,2.692,0,0,1-1.353-1.158,3.621,3.621,0,0,1-.664-2.065c0-.943.205-1.413.608-1.413q.468,0,.468.447v2.247h.875v-2.24a.386.386,0,0,1,.191-.323.75.75,0,0,1,.426-.131.72.72,0,0,1,.417.133.394.394,0,0,1,.191.328v2.233h.876v-2.24a.4.4,0,0,1,.458-.454q.61,0,.61,1.4a3.536,3.536,0,0,1-.666,2.088Z"
                transform="translate(-228.516 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_462"
                data-name="Path 462"
                d="M454.336,336.382a1.811,1.811,0,0,0-1.4.615,1.868,1.868,0,0,0-2.913.177,3.018,3.018,0,0,0-.456,1.7,5.042,5.042,0,0,0,1.062,2.672l.731-.5a4.2,4.2,0,0,1-.917-2.175c0-1.076.373-1.613,1.111-1.613a1.261,1.261,0,0,1,.675.172.538.538,0,0,1,.275.468v2.149h.875v-2.107a.57.57,0,0,1,.314-.524,1.248,1.248,0,0,1,.641-.159q1.118,0,1.118,1.613a4.208,4.208,0,0,1-.915,2.175l.726.5a5,5,0,0,0,1.063-2.672,3.012,3.012,0,0,0-.454-1.7A1.736,1.736,0,0,0,454.336,336.382Z"
                transform="translate(-232.177 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_463"
                data-name="Path 463"
                d="M468.058,330.743a1.627,1.627,0,0,0-1.348.661,2.007,2.007,0,0,0-3.49,1.343,1.956,1.956,0,0,0,.633,1.462l.324.3.605-.64a6.513,6.513,0,0,1-.475-.485,1.052,1.052,0,0,1-.211-.64,1.084,1.084,0,0,1,.328-.791,1.114,1.114,0,0,1,.808-.331,1.134,1.134,0,0,1,1.129,1.122V333.9h.875v-1.434a.811.811,0,0,1,.242-.6.789.789,0,0,1,.585-.245.847.847,0,0,1,.84.841v3.073a2.666,2.666,0,0,0-1.825-.572,2.881,2.881,0,0,0-1.888.628,2.247,2.247,0,0,0-.826,1.825,2.222,2.222,0,0,0,.826,1.812,3.141,3.141,0,0,0,3.77,0,2.228,2.228,0,0,0,.824-1.812v-4.954a1.733,1.733,0,0,0-1.725-1.723Zm.28,7.863a2.319,2.319,0,0,1-2.522,0,1.382,1.382,0,0,1-.577-1.185,1.4,1.4,0,0,1,.566-1.193,2.076,2.076,0,0,1,1.274-.379,2.044,2.044,0,0,1,1.281.387,1.424,1.424,0,0,1,.544,1.185A1.4,1.4,0,0,1,468.337,338.606Z"
                transform="translate(-235.852 -330.117)"
                fill="#fff"
              />
              <path
                id="Path_464"
                data-name="Path 464"
                d="M480.211,336.383a2.673,2.673,0,0,0-1.9.754,2.761,2.761,0,0,0-.88,1.858,3.922,3.922,0,0,0,.826,2.211l.271.35.7-.546A3.792,3.792,0,0,1,478.3,339a1.863,1.863,0,0,1,.617-1.238A1.91,1.91,0,0,1,482.111,339a3.781,3.781,0,0,1-.917,2.01l.7.546A4.664,4.664,0,0,0,482.987,339a2.771,2.771,0,0,0-.877-1.858A2.669,2.669,0,0,0,480.211,336.383Z"
                transform="translate(-239.678 -331.635)"
                fill="#fff"
              />
              <path
                id="Path_465"
                data-name="Path 465"
                d="M498.249,334.208v-3.315c.279-.026.419-.17.419-.426,0-.282-.172-.422-.524-.422h-.865l-1.057,2.559-1.068-2.559h-.862c-.349,0-.523.14-.523.422,0,.256.14.4.422.426v3.315c-.327,0-.489.143-.489.426s.174.419.524.419h1.033c.349,0,.522-.14.522-.419a.423.423,0,0,0-.138-.324.552.552,0,0,0-.384-.1h-.284v-2.517l.91,2.179h.685l.893-2.184v2.522h-.284q-.524,0-.524.426t.524.419h1.033q.524,0,.524-.419C498.738,334.351,498.572,334.208,498.249,334.208Z"
                transform="translate(-244.06 -329.929)"
                fill="#fff"
              />
              <path
                id="Path_466"
                data-name="Path 466"
                d="M492.229,330.045h-4.064V331.7c0,.374.132.563.393.563s.393-.189.393-.563v-.808h.848v3.315h-.524q-.524,0-.524.447c0,.267.175.4.524.4h1.839c.349,0,.525-.14.525-.419s-.176-.426-.525-.426h-.531v-3.315h.861v.808c0,.374.133.563.394.563s.391-.189.391-.563Z"
                transform="translate(-242.569 -329.929)"
                fill="#fff"
              />
            </g>
          </g>
        </svg>

        <div class="timeline__scroll-sign">
          <span class="wc white bold-italic f-16">{{
            $fn.tr("დასქროლე")
          }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46.487"
            height="22.036"
            viewBox="0 0 46.487 22.036"
          >
            <g
              id="Group_506"
              data-name="Group 506"
              transform="translate(34.858 3.372) rotate(90)"
            >
              <g id="menu" transform="translate(0 0)">
                <g
                  id="Group_103"
                  data-name="Group 103"
                  transform="translate(0 0)"
                >
                  <path
                    id="Union_6"
                    data-name="Union 6"
                    d="M14.265,18.651a58.664,58.664,0,0,1,7.447-5.2,24.173,24.173,0,0,1,2.613-1.368q-.109-.028-.216-.059a49.245,49.245,0,0,0-8.662.036c-1.76.11-3.5.22-5.166.219-7.136-.007-14.223-.642-21.373-.3-2.462.115-6.585-2.223-2.418-2.421,4.456-.212,8.879-.064,13.3.085,3.621.122,7.242.243,10.884.167,4.948-.1,10.317-.76,15.181.049.094.016.189.032.286.051-2.632-2.721-5.6-5.12-7.845-8.2C17.6.754,18.154-.806,19.107.5c2.79,3.823,6.7,6.609,9.694,10.262.507.618.432,1.5.023,1.653a1.434,1.434,0,0,1-.941.424c-2.147.143-4.13,1.376-5.9,2.52a65.656,65.656,0,0,0-6.131,4.375,1.417,1.417,0,0,1-.9.3C14.115,20.034,13.35,19.406,14.265,18.651Z"
                    transform="translate(-2.37 18.527) rotate(-90)"
                    fill="#bacb32"
                    stroke="#bacb32"
                    stroke-width="2"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <Footer v-if="windowWidth <= 1023" />
    </SmoothScrollTimeline>
    <div class="timeline__footer" v-if="windowWidth >= 1024">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="255"
        height="49.7"
        viewBox="0 0 255 49.7"
      >
        <g
          id="Group_3508"
          data-name="Group 3508"
          transform="translate(-151.635 -280.655)"
        >
          <g
            id="Group_127"
            data-name="Group 127"
            transform="translate(151.635 280.655)"
          >
            <rect
              id="Rectangle_509"
              data-name="Rectangle 509"
              width="2.544"
              height="31.749"
              transform="translate(5.101)"
              fill="#fff"
            />
            <rect
              id="Rectangle_510"
              data-name="Rectangle 510"
              width="2.544"
              height="31.749"
              fill="#fff"
            />
            <rect
              id="Rectangle_511"
              data-name="Rectangle 511"
              width="5.103"
              height="31.749"
              transform="translate(10.195)"
              fill="#fff"
            />
            <rect
              id="Rectangle_512"
              data-name="Rectangle 512"
              width="7.653"
              height="31.749"
              transform="translate(17.85)"
              fill="#fff"
            />
            <rect
              id="Rectangle_513"
              data-name="Rectangle 513"
              width="2.547"
              height="31.749"
              transform="translate(35.703)"
              fill="#fff"
            />
            <rect
              id="Rectangle_514"
              data-name="Rectangle 514"
              width="2.547"
              height="31.749"
              transform="translate(40.809)"
              fill="#fff"
            />
            <rect
              id="Rectangle_515"
              data-name="Rectangle 515"
              width="5.105"
              height="31.749"
              transform="translate(51.004)"
              fill="#fff"
            />
            <rect
              id="Rectangle_516"
              data-name="Rectangle 516"
              width="2.549"
              height="31.749"
              transform="translate(58.657)"
              fill="#fff"
            />
            <rect
              id="Rectangle_517"
              data-name="Rectangle 517"
              width="5.104"
              height="31.749"
              transform="translate(68.856)"
              fill="#fff"
            />
            <rect
              id="Rectangle_518"
              data-name="Rectangle 518"
              width="2.547"
              height="31.749"
              transform="translate(94.362)"
              fill="#fff"
            />
            <rect
              id="Rectangle_519"
              data-name="Rectangle 519"
              width="2.547"
              height="31.749"
              transform="translate(89.261)"
              fill="#fff"
            />
            <rect
              id="Rectangle_520"
              data-name="Rectangle 520"
              width="2.546"
              height="31.749"
              transform="translate(76.508)"
              fill="#fff"
            />
            <rect
              id="Rectangle_521"
              data-name="Rectangle 521"
              width="7.651"
              height="31.749"
              transform="translate(99.463)"
              fill="#fff"
            />
            <rect
              id="Rectangle_522"
              data-name="Rectangle 522"
              width="2.55"
              height="31.749"
              transform="translate(122.415)"
              fill="#fff"
            />
            <rect
              id="Rectangle_523"
              data-name="Rectangle 523"
              width="2.546"
              height="31.749"
              transform="translate(117.316)"
              fill="#fff"
            />
            <rect
              id="Rectangle_524"
              data-name="Rectangle 524"
              width="2.552"
              height="31.749"
              transform="translate(82.346)"
              fill="#fff"
            />
            <rect
              id="Rectangle_525"
              data-name="Rectangle 525"
              width="2.542"
              height="31.749"
              transform="translate(186.972)"
              fill="#fff"
            />
            <rect
              id="Rectangle_526"
              data-name="Rectangle 526"
              width="2.547"
              height="31.749"
              transform="translate(112.215)"
              fill="#fff"
            />
            <rect
              id="Rectangle_527"
              data-name="Rectangle 527"
              width="7.641"
              height="31.749"
              transform="translate(127.518)"
              fill="#fff"
            />
            <rect
              id="Rectangle_528"
              data-name="Rectangle 528"
              width="2.547"
              height="31.749"
              transform="translate(140.265)"
              fill="#fff"
            />
            <rect
              id="Rectangle_529"
              data-name="Rectangle 529"
              width="5.097"
              height="31.749"
              transform="translate(155.566)"
              fill="#fff"
            />
            <rect
              id="Rectangle_530"
              data-name="Rectangle 530"
              width="5.101"
              height="31.749"
              transform="translate(145.366)"
              fill="#fff"
            />
            <rect
              id="Rectangle_531"
              data-name="Rectangle 531"
              width="2.544"
              height="31.749"
              transform="translate(163.222)"
              fill="#fff"
            />
            <rect
              id="Rectangle_532"
              data-name="Rectangle 532"
              width="7.649"
              height="31.749"
              transform="translate(168.325)"
              fill="#fff"
            />
            <rect
              id="Rectangle_533"
              data-name="Rectangle 533"
              width="2.552"
              height="31.749"
              transform="translate(181.074)"
              fill="#fff"
            />
            <rect
              id="Rectangle_534"
              data-name="Rectangle 534"
              width="2.547"
              height="31.749"
              transform="translate(193.828)"
              fill="#fff"
            />
            <rect
              id="Rectangle_535"
              data-name="Rectangle 535"
              width="5.101"
              height="31.749"
              transform="translate(226.978)"
              fill="#fff"
            />
            <rect
              id="Rectangle_536"
              data-name="Rectangle 536"
              width="5.104"
              height="31.749"
              transform="translate(206.571)"
              fill="#fff"
            />
            <rect
              id="Rectangle_537"
              data-name="Rectangle 537"
              width="5.103"
              height="31.749"
              transform="translate(216.778)"
              fill="#fff"
            />
            <rect
              id="Rectangle_538"
              data-name="Rectangle 538"
              width="5.1"
              height="31.749"
              transform="translate(198.924)"
              fill="#fff"
            />
            <rect
              id="Rectangle_539"
              data-name="Rectangle 539"
              width="2.544"
              height="31.749"
              transform="translate(234.633)"
              fill="#fff"
            />
            <rect
              id="Rectangle_540"
              data-name="Rectangle 540"
              width="2.547"
              height="31.749"
              transform="translate(239.732)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_128"
            data-name="Group 128"
            transform="translate(151.957 316.63)"
          >
            <path
              id="Path_441"
              data-name="Path 441"
              d="M155,340.693a1.973,1.973,0,0,0,1.635.751,2.08,2.08,0,0,0,1.664-.8,2.655,2.655,0,0,0,.627-1.765,4.425,4.425,0,0,0-.047-.792,2.1,2.1,0,0,0-.8-1.247,2.185,2.185,0,0,0-1.362-.468,1.958,1.958,0,0,0-1.2.392,2.1,2.1,0,0,0-1.243-.392,2.163,2.163,0,0,0-1.521.593,2.049,2.049,0,0,0-.683,1.589v.387a3.525,3.525,0,0,0,.875,2.365h-.572l-.009.882h.441q3.556.022,4.838,2.754l.186.4.8-.378a6.169,6.169,0,0,0-3.67-3.386,2.631,2.631,0,0,1-2.014-2.642v-.387a1.294,1.294,0,0,1,1.3-1.295,1.207,1.207,0,0,1,.659.171,2.909,2.909,0,0,0-.447,1.6A2.576,2.576,0,0,0,155,340.693Zm.46-2.389a2.441,2.441,0,0,1,.5-.773,1.185,1.185,0,0,1,.783-.275,1.365,1.365,0,0,1,.868.3,1.1,1.1,0,0,1,.426.794c.007.11.012.222.012.333q0,1.879-1.415,1.877a1.27,1.27,0,0,1-.921-.376,1.216,1.216,0,0,1-.374-.913A3.016,3.016,0,0,1,155.464,338.3Z"
              transform="translate(-152.076 -331.633)"
              fill="#fff"
            />
            <path
              id="Path_442"
              data-name="Path 442"
              d="M170.29,336.092a1.287,1.287,0,0,1-.769-.559,3.334,3.334,0,0,1-.321-.9l-.854.215.1.428a2.078,2.078,0,0,0,.927,1.3l1.2.661a1.365,1.365,0,0,1,.594,1.192,1.4,1.4,0,0,1-.6,1.213,2.2,2.2,0,0,1-1.313.38,2.224,2.224,0,0,1-1.312-.373,1.409,1.409,0,0,1-.6-1.22,1.475,1.475,0,0,1,.21-.771l.217-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.234,2.234,0,0,0,.862,1.846,3.267,3.267,0,0,0,3.855,0,2.241,2.241,0,0,0,.859-1.846,2.383,2.383,0,0,0-.494-1.472A2.349,2.349,0,0,0,170.29,336.092Z"
              transform="translate(-155.952 -331.165)"
              fill="#fff"
            />
            <path
              id="Path_443"
              data-name="Path 443"
              d="M182.781,330.743a2.915,2.915,0,0,0-1.937.661,2.308,2.308,0,0,0-.856,1.867,3.644,3.644,0,0,0,.43,1.456l.791-.373a2.875,2.875,0,0,1-.347-1.083,1.473,1.473,0,0,1,.6-1.239,2.1,2.1,0,0,1,1.318-.408,2.077,2.077,0,0,1,1.308.4,1.458,1.458,0,0,1,.6,1.241v2.2a2.281,2.281,0,0,0-1.614-.6,2.5,2.5,0,1,0,2.489,2.5v-4.1a2.3,2.3,0,0,0-.853-1.867A2.923,2.923,0,0,0,182.781,330.743Zm1.432,7.763a1.613,1.613,0,1,1,.007-2.284,1.636,1.636,0,0,1-.007,2.284Z"
              transform="translate(-159.591 -330.117)"
              fill="#fff"
            />
            <path
              id="Path_444"
              data-name="Path 444"
              d="M197.541,335.07l1.269-.957-.531-.7-2.183,1.648a5.482,5.482,0,0,0,.468-1.86,6.086,6.086,0,0,0,0-.615,1.841,1.841,0,0,0-.56-1.3,1.777,1.777,0,0,0-1.3-.538,1.7,1.7,0,0,0-1.413.675,2.535,2.535,0,0,0,0,2.943,1.706,1.706,0,0,0,1.413.668,1.848,1.848,0,0,0,.551-.083q-.443,1.117-.468,1.212a3.924,3.924,0,0,0-.241,1.276,2.428,2.428,0,0,0,4.856,0,2.437,2.437,0,0,0-1.86-2.365Zm-2.833-.922a.9.9,0,0,1-.761-.391,1.452,1.452,0,0,1-.251-.862,1.409,1.409,0,0,1,.258-.867.866.866,0,0,1,.755-.4.949.949,0,0,1,.7.291.908.908,0,0,1,.284.694,8.02,8.02,0,0,1-.013.876A1.176,1.176,0,0,1,194.708,334.148Zm3.362,4.379a1.555,1.555,0,0,1-2.193,0,1.467,1.467,0,0,1-.454-1.092,1.562,1.562,0,0,1,1.548-1.55,1.553,1.553,0,0,1,1.555,1.55A1.472,1.472,0,0,1,198.07,338.526Z"
              transform="translate(-163.046 -330.117)"
              fill="#fff"
            />
            <path
              id="Path_445"
              data-name="Path 445"
              d="M210.849,336.092a1.283,1.283,0,0,1-.77-.559,3.336,3.336,0,0,1-.321-.9l-.854.215.1.428a2.083,2.083,0,0,0,.924,1.3c.4.221.8.44,1.2.661a1.361,1.361,0,0,1,.6,1.192,1.4,1.4,0,0,1-.6,1.213,2.189,2.189,0,0,1-1.313.38,2.224,2.224,0,0,1-1.312-.373,1.412,1.412,0,0,1-.6-1.22,1.484,1.484,0,0,1,.211-.771l.217-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.23,2.23,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.245,2.245,0,0,0,.856-1.846,2.371,2.371,0,0,0-.5-1.472A2.338,2.338,0,0,0,210.849,336.092Z"
              transform="translate(-166.872 -331.165)"
              fill="#fff"
            />
            <path
              id="Path_446"
              data-name="Path 446"
              d="M222.6,340.693a1.974,1.974,0,0,0,1.632.751,2.086,2.086,0,0,0,1.669-.8,2.689,2.689,0,0,0,.626-1.765,4.3,4.3,0,0,0-.049-.792,2.088,2.088,0,0,0-.8-1.247,2.193,2.193,0,0,0-1.364-.468,1.958,1.958,0,0,0-1.2.392,2.1,2.1,0,0,0-1.241-.392,2.166,2.166,0,0,0-1.523.593,2.054,2.054,0,0,0-.683,1.589v.387a3.493,3.493,0,0,0,.876,2.365h-.571l-.012.882h.445q3.555.022,4.835,2.754l.186.4.8-.378a6.158,6.158,0,0,0-3.669-3.386,2.632,2.632,0,0,1-2.014-2.642v-.387a1.3,1.3,0,0,1,1.3-1.295,1.222,1.222,0,0,1,.664.171,2.893,2.893,0,0,0-.45,1.6A2.573,2.573,0,0,0,222.6,340.693Zm.456-2.389a2.58,2.58,0,0,1,.5-.773,1.184,1.184,0,0,1,.783-.275,1.37,1.37,0,0,1,.869.3,1.1,1.1,0,0,1,.425.794c.007.11.015.222.015.333q0,1.879-1.421,1.877a1.258,1.258,0,0,1-.915-.376,1.2,1.2,0,0,1-.379-.913A3.127,3.127,0,0,1,223.058,338.3Z"
              transform="translate(-170.276 -331.633)"
              fill="#fff"
            />
            <path
              id="Path_447"
              data-name="Path 447"
              d="M238.886,336.865a2.9,2.9,0,0,0-1.719-.483,3.836,3.836,0,0,0-.882.089,2.076,2.076,0,0,0-1.211.777,2.139,2.139,0,0,0-.449,1.311,1.972,1.972,0,0,0,.394,1.206l.968-.151a2.341,2.341,0,0,1-.476-1.206.942.942,0,0,1,.569-.894,2.283,2.283,0,0,1,1.09-.249c1.076,0,1.618.4,1.618,1.2v4.175q0,1.679-1.916,1.681a2.24,2.24,0,0,1-1.369-.384,1.515,1.515,0,0,1-.594-1.3,2.16,2.16,0,0,1,.908-1.7h-1.025a4.216,4.216,0,0,0-.539.628,2.178,2.178,0,0,0-.217,1.073,2.348,2.348,0,0,0,.85,1.923,3.036,3.036,0,0,0,1.986.64,2.947,2.947,0,0,0,1.962-.633,2.39,2.39,0,0,0,.829-1.931v-4.175A1.837,1.837,0,0,0,238.886,336.865Z"
              transform="translate(-174.144 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_448"
              data-name="Path 448"
              d="M251.9,335.518a1.644,1.644,0,0,1-.573-.826,1.847,1.847,0,0,1-.06-.409v-1.206a1.31,1.31,0,0,0-1.306-1.3h-.436a.376.376,0,0,1-.431-.422h-.875a8.42,8.42,0,0,1-.275,2.194l-.11.425.855.221a12.535,12.535,0,0,0,.342-1.634,1.276,1.276,0,0,0,.5.1h.436a.368.368,0,0,1,.417.419c0,.82,0,1.248.009,1.29q-.9.659-1.793,1.322a2.388,2.388,0,0,0-.955,1.9,2.2,2.2,0,0,0,.853,1.825,3.226,3.226,0,0,0,3.8-.007,2.21,2.21,0,0,0,.852-1.818,2.039,2.039,0,0,0-.424-1.309A7.789,7.789,0,0,0,251.9,335.518Zm-.216,3.259a2.443,2.443,0,0,1-2.573,0,1.375,1.375,0,0,1-.6-1.192,1.445,1.445,0,0,1,.756-1.309,11.8,11.8,0,0,0,1.353-.959,5.159,5.159,0,0,0,1.01,1.048,1.609,1.609,0,0,1,.636,1.22A1.386,1.386,0,0,1,251.68,338.777Z"
              transform="translate(-177.807 -330.282)"
              fill="#fff"
            />
            <path
              id="Path_449"
              data-name="Path 449"
              d="M265.449,336.318a1.584,1.584,0,0,0-1.073.406,1.249,1.249,0,0,0-1.8-.042,1.216,1.216,0,0,0-.372.878c-.007.568-.179.854-.524.854a.506.506,0,0,1-.419-.221.656.656,0,0,1,.116-.966c.058-.049.223-.167.5-.349l-.493-.731a4.369,4.369,0,0,0-.8.643,1.426,1.426,0,0,0-.359.95,1.61,1.61,0,0,0,.417,1.09,1.388,1.388,0,0,0,2.021.056,1.371,1.371,0,0,0,.414-.983,1.967,1.967,0,0,1,.033-.452.366.366,0,0,1,.712.116v2.328h.875v-2.018a.7.7,0,0,1,.247-.482.764.764,0,0,1,1.276.563v4.617q0,1.68-1.918,1.681a2.249,2.249,0,0,1-1.367-.384,1.519,1.519,0,0,1-.6-1.3,1.491,1.491,0,0,1,.279-.9,3.668,3.668,0,0,1,.677-.656l-.55-.69a4.4,4.4,0,0,0-.922.964,2.322,2.322,0,0,0-.358,1.283,2.349,2.349,0,0,0,.852,1.923,3.035,3.035,0,0,0,1.984.64,2.954,2.954,0,0,0,1.966-.633,2.389,2.389,0,0,0,.827-1.931v-4.617a1.638,1.638,0,0,0-1.643-1.639Z"
              transform="translate(-181.195 -331.572)"
              fill="#fff"
            />
            <path
              id="Path_450"
              data-name="Path 450"
              d="M278.937,340.937h1.033a5.423,5.423,0,0,0,.482-.957,4.37,4.37,0,0,0,.159-1.311q0-2.284-1.49-2.286a1.2,1.2,0,0,0-.936.391,1.442,1.442,0,0,0-1.006-.391,1.475,1.475,0,0,0-1.02.391,1.177,1.177,0,0,0-.931-.391q-1.489,0-1.488,2.3a4.357,4.357,0,0,0,1.29,3.155c-.479.077-.836.144-1.076.2l.193.859a7.159,7.159,0,0,1,1.418-.2,5.127,5.127,0,0,1,1.138.13,4.78,4.78,0,0,1,3,2.542l.767-.433a6.389,6.389,0,0,0-1.542-1.871,7.308,7.308,0,0,0-2.3-1.155,2.7,2.7,0,0,1-1.353-1.158,3.63,3.63,0,0,1-.662-2.065c0-.943.2-1.413.611-1.413q.465,0,.466.447v2.247h.875v-2.24a.381.381,0,0,1,.191-.323.752.752,0,0,1,.427-.131.73.73,0,0,1,.417.133.4.4,0,0,1,.191.328v2.233h.875v-2.24a.4.4,0,0,1,.458-.454c.4,0,.61.468.61,1.4a3.534,3.534,0,0,1-.669,2.088Z"
              transform="translate(-184.835 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_451"
              data-name="Path 451"
              d="M290.939,336.383a2.673,2.673,0,0,0-1.9.754,2.773,2.773,0,0,0-.88,1.858,3.93,3.93,0,0,0,.828,2.211l.268.35.7-.546a3.811,3.811,0,0,1-.918-2.01,1.867,1.867,0,0,1,.617-1.238A1.91,1.91,0,0,1,292.839,339a3.81,3.81,0,0,1-.913,2.01l.694.546A4.683,4.683,0,0,0,293.714,339a2.759,2.759,0,0,0-.875-1.858A2.672,2.672,0,0,0,290.939,336.383Z"
              transform="translate(-188.716 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_452"
              data-name="Path 452"
              d="M305.485,336.092a1.26,1.26,0,0,1-.766-.559,3.22,3.22,0,0,1-.324-.9l-.855.215.106.428a2.07,2.07,0,0,0,.927,1.3c.4.221.8.44,1.2.661a1.357,1.357,0,0,1,.592,1.192,1.4,1.4,0,0,1-.592,1.213,2.2,2.2,0,0,1-1.313.38,2.238,2.238,0,0,1-1.315-.373,1.41,1.41,0,0,1-.6-1.22,1.524,1.524,0,0,1,.209-.771l.22-.387-.757-.433a3.336,3.336,0,0,0-.547,1.59,2.228,2.228,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.243,2.243,0,0,0,.852-1.846,2.428,2.428,0,0,0-1.753-2.342Z"
              transform="translate(-192.354 -331.165)"
              fill="#fff"
            />
            <path
              id="Path_453"
              data-name="Path 453"
              d="M333.189,335.4c-.252-.193-.379-.344-.379-.456a.252.252,0,0,1,.286-.282h.445v-.882h-.44a1.113,1.113,0,0,0-.825.342,1.138,1.138,0,0,0,.041,1.665c.224.2.458.4.693.6a1.4,1.4,0,0,1,.373.995,1.419,1.419,0,0,1-.587,1.21,2.077,2.077,0,0,1-1.288.394,2.031,2.031,0,0,1-1.291-.4,1.428,1.428,0,0,1-.59-1.213v-6.621h-.875v6.621a2.294,2.294,0,0,0,.848,1.85,3.151,3.151,0,0,0,3.819,0,2.28,2.28,0,0,0,.84-1.844,2.245,2.245,0,0,0-.373-1.3A3.715,3.715,0,0,0,333.189,335.4Z"
              transform="translate(-199.646 -330.117)"
              fill="#fff"
            />
            <path
              id="Path_454"
              data-name="Path 454"
              d="M346.042,336.092a1.278,1.278,0,0,1-.767-.559,3.336,3.336,0,0,1-.321-.9l-.854.215.1.428a2.09,2.09,0,0,0,.927,1.3l1.2.661a1.364,1.364,0,0,1,.594,1.192,1.4,1.4,0,0,1-.6,1.213,2.2,2.2,0,0,1-1.312.38,2.223,2.223,0,0,1-1.313-.373,1.409,1.409,0,0,1-.6-1.22,1.509,1.509,0,0,1,.208-.771l.218-.387-.756-.433a3.337,3.337,0,0,0-.545,1.59,2.228,2.228,0,0,0,.862,1.846,3.271,3.271,0,0,0,3.858,0,2.247,2.247,0,0,0,.856-1.846,2.438,2.438,0,0,0-1.76-2.342Z"
              transform="translate(-203.274 -331.165)"
              fill="#fff"
            />
            <path
              id="Path_455"
              data-name="Path 455"
              d="M358.938,331.514l-.433.074.141.869a5.343,5.343,0,0,0,1.842-.594v3.453h-2.049a1.614,1.614,0,0,0-1.623,1.616,1.525,1.525,0,0,0,.71,1.334l.36.247.5-.726c-.267-.181-.421-.294-.476-.34a.7.7,0,0,1-.225-.512.721.721,0,0,1,.219-.522.7.7,0,0,1,.519-.214h2.063v4.67a1.477,1.477,0,0,1-.622,1.269,2.567,2.567,0,0,1-2.731,0,1.48,1.48,0,0,1-.631-1.269,1.451,1.451,0,0,1,.275-.881,3.749,3.749,0,0,1,.664-.647l-.56-.684a4.418,4.418,0,0,0-.9.946,2.451,2.451,0,0,0,.538,3.161,3.351,3.351,0,0,0,3.96,0,2.288,2.288,0,0,0,.883-1.888V329.886c-.56.566-.918.905-1.071,1.027A3.06,3.06,0,0,1,358.938,331.514Z"
              transform="translate(-206.883 -329.886)"
              fill="#fff"
            />
            <path
              id="Path_456"
              data-name="Path 456"
              d="M373.079,336.092a1.27,1.27,0,0,1-.764-.559,3.316,3.316,0,0,1-.324-.9l-.854.215.105.428a2.068,2.068,0,0,0,.929,1.3l1.2.661a1.366,1.366,0,0,1,.6,1.192,1.407,1.407,0,0,1-.6,1.213,2.189,2.189,0,0,1-1.313.38,2.248,2.248,0,0,1-1.317-.373,1.407,1.407,0,0,1-.6-1.22,1.517,1.517,0,0,1,.21-.771l.221-.387-.759-.433a3.361,3.361,0,0,0-.545,1.59,2.234,2.234,0,0,0,.862,1.846,3.274,3.274,0,0,0,3.86,0,2.242,2.242,0,0,0,.85-1.846,2.388,2.388,0,0,0-.49-1.472A2.346,2.346,0,0,0,373.079,336.092Z"
              transform="translate(-210.554 -331.165)"
              fill="#fff"
            />
            <path
              id="Path_457"
              data-name="Path 457"
              d="M386.739,334.866a1.811,1.811,0,0,0-1.4.615,1.734,1.734,0,0,0-1.378-.615h-.015a3.036,3.036,0,0,1,1.407-.723,2.967,2.967,0,0,0,1.683-1.057,2.936,2.936,0,0,0,.666-1.893v-.44h-.876v.443a2.1,2.1,0,0,1-1.261,1.887q-1.167.628-2.333,1.262a3.657,3.657,0,0,0-1.262,3.027,4.113,4.113,0,0,0,.813,2.3l.248.363.731-.5a4.187,4.187,0,0,1-.917-2.172q0-1.624,1.108-1.623a1.234,1.234,0,0,1,.675.175.545.545,0,0,1,.278.473v2.143h.875v-2.075a.6.6,0,0,1,.31-.55,1.2,1.2,0,0,1,.649-.165q1.114,0,1.114,1.618a4.248,4.248,0,0,1-.916,2.179l.729.494a5.025,5.025,0,0,0,1.062-2.673,2.973,2.973,0,0,0-.454-1.7A1.727,1.727,0,0,0,386.739,334.866Z"
              transform="translate(-213.976 -330.119)"
              fill="#fff"
            />
            <path
              id="Path_458"
              data-name="Path 458"
              d="M400.329,336.354a1.6,1.6,0,0,0-1.193.5,2.075,2.075,0,0,0-1.376-.5,2.038,2.038,0,0,0-1.5.624,2.134,2.134,0,0,0-.647,1.511c-.007.363-.007.615,0,.752.015.207.037.36.051.463h0a2.161,2.161,0,0,0,2.1,1.667,2.043,2.043,0,0,0,1.513-.634,2.13,2.13,0,0,0,.638-1.51,3.842,3.842,0,0,0-.228-1.633.767.767,0,0,1,.65-.358.841.841,0,0,1,.775.6,2.48,2.48,0,0,1,.207,1.027,2.378,2.378,0,0,1-.284,1.16,4.794,4.794,0,0,1-.734.921l.632.615a5.312,5.312,0,0,0,.918-1.215,3.2,3.2,0,0,0,.344-1.48,3.091,3.091,0,0,0-.437-1.668A1.584,1.584,0,0,0,400.329,336.354Zm-1.293,2.862a1.24,1.24,0,0,1-.384.9,1.222,1.222,0,0,1-.892.373,1.238,1.238,0,0,1-.8-.284,1.27,1.27,0,0,1-.449-.707c-.016-.2-.023-.31-.023-.338v-.635a1.268,1.268,0,0,1,.376-.906,1.209,1.209,0,0,1,.9-.381,1.31,1.31,0,0,1,1.06.577,1.85,1.85,0,0,1,.216.675C399.044,338.554,399.044,338.8,399.036,339.216Z"
              transform="translate(-217.647 -331.628)"
              fill="#fff"
            />
            <path
              id="Path_459"
              data-name="Path 459"
              d="M413.741,336.438a4.843,4.843,0,0,0-.826-.056,3.86,3.86,0,0,0-.881.088,2.23,2.23,0,0,0-1.178.718,1.756,1.756,0,0,0-.475,1.248,2.36,2.36,0,0,0,.389,1.329l.971-.151a2.282,2.282,0,0,1-.484-1.206.941.941,0,0,1,.569-.894,2.28,2.28,0,0,1,1.09-.249q1.613,0,1.616,1.2v.177a1.214,1.214,0,0,1-1.185,1.187h-.865v.867h1a.917.917,0,0,1,.734.356,1.285,1.285,0,0,1,.314.831,3.543,3.543,0,0,1-.3,1.784,1.746,1.746,0,0,1-1.609.654,2.231,2.231,0,0,1-1.369-.384,1.512,1.512,0,0,1-.6-1.3,1.576,1.576,0,0,1,.622-1.283l.338-.275-1.123-.144c-.153.2-.3.394-.447.586a2.181,2.181,0,0,0-.265,1.116,2.339,2.339,0,0,0,.857,1.923,3.018,3.018,0,0,0,1.982.64,2.97,2.97,0,0,0,1.969-.64,2.347,2.347,0,0,0,.819-1.923v-.757a2,2,0,0,0-.807-1.627,1.843,1.843,0,0,0,.807-1.614v-.177a2.062,2.062,0,0,0-1.667-2.026Z"
              transform="translate(-221.464 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_460"
              data-name="Path 460"
              d="M428.155,336.865a2.881,2.881,0,0,0-1.716-.483,3.816,3.816,0,0,0-.883.089,2.053,2.053,0,0,0-1.208.777,2.111,2.111,0,0,0-.453,1.311,1.973,1.973,0,0,0,.395,1.206l.973-.151a2.276,2.276,0,0,1-.48-1.206.942.942,0,0,1,.569-.894,2.269,2.269,0,0,1,1.092-.249c1.075,0,1.616.4,1.616,1.2v4.175q0,1.679-1.916,1.681a2.239,2.239,0,0,1-1.369-.384,1.509,1.509,0,0,1-.594-1.3,2.158,2.158,0,0,1,.908-1.7h-1.027a4.522,4.522,0,0,0-.539.628,2.2,2.2,0,0,0-.217,1.073,2.356,2.356,0,0,0,.849,1.923,3.047,3.047,0,0,0,1.989.64,2.947,2.947,0,0,0,1.962-.633,2.392,2.392,0,0,0,.829-1.931v-4.175A1.836,1.836,0,0,0,428.155,336.865Z"
              transform="translate(-225.105 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_461"
              data-name="Path 461"
              d="M441.169,340.937H442.2a5.636,5.636,0,0,0,.482-.957,4.44,4.44,0,0,0,.159-1.311q0-2.284-1.49-2.286a1.193,1.193,0,0,0-.934.391,1.451,1.451,0,0,0-1.008-.391,1.478,1.478,0,0,0-1.019.391,1.183,1.183,0,0,0-.932-.391q-1.489,0-1.487,2.3a4.375,4.375,0,0,0,1.287,3.155c-.479.077-.833.144-1.073.2l.192.859a7.182,7.182,0,0,1,1.421-.2,5.158,5.158,0,0,1,1.136.13,4.782,4.782,0,0,1,3,2.542l.764-.433a6.371,6.371,0,0,0-1.539-1.871,7.319,7.319,0,0,0-2.3-1.155,2.692,2.692,0,0,1-1.353-1.158,3.621,3.621,0,0,1-.664-2.065c0-.943.205-1.413.608-1.413q.468,0,.468.447v2.247h.875v-2.24a.386.386,0,0,1,.191-.323.75.75,0,0,1,.426-.131.72.72,0,0,1,.417.133.394.394,0,0,1,.191.328v2.233h.876v-2.24a.4.4,0,0,1,.458-.454q.61,0,.61,1.4a3.536,3.536,0,0,1-.666,2.088Z"
              transform="translate(-228.516 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_462"
              data-name="Path 462"
              d="M454.336,336.382a1.811,1.811,0,0,0-1.4.615,1.868,1.868,0,0,0-2.913.177,3.018,3.018,0,0,0-.456,1.7,5.042,5.042,0,0,0,1.062,2.672l.731-.5a4.2,4.2,0,0,1-.917-2.175c0-1.076.373-1.613,1.111-1.613a1.261,1.261,0,0,1,.675.172.538.538,0,0,1,.275.468v2.149h.875v-2.107a.57.57,0,0,1,.314-.524,1.248,1.248,0,0,1,.641-.159q1.118,0,1.118,1.613a4.208,4.208,0,0,1-.915,2.175l.726.5a5,5,0,0,0,1.063-2.672,3.012,3.012,0,0,0-.454-1.7A1.736,1.736,0,0,0,454.336,336.382Z"
              transform="translate(-232.177 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_463"
              data-name="Path 463"
              d="M468.058,330.743a1.627,1.627,0,0,0-1.348.661,2.007,2.007,0,0,0-3.49,1.343,1.956,1.956,0,0,0,.633,1.462l.324.3.605-.64a6.513,6.513,0,0,1-.475-.485,1.052,1.052,0,0,1-.211-.64,1.084,1.084,0,0,1,.328-.791,1.114,1.114,0,0,1,.808-.331,1.134,1.134,0,0,1,1.129,1.122V333.9h.875v-1.434a.811.811,0,0,1,.242-.6.789.789,0,0,1,.585-.245.847.847,0,0,1,.84.841v3.073a2.666,2.666,0,0,0-1.825-.572,2.881,2.881,0,0,0-1.888.628,2.247,2.247,0,0,0-.826,1.825,2.222,2.222,0,0,0,.826,1.812,3.141,3.141,0,0,0,3.77,0,2.228,2.228,0,0,0,.824-1.812v-4.954a1.733,1.733,0,0,0-1.725-1.723Zm.28,7.863a2.319,2.319,0,0,1-2.522,0,1.382,1.382,0,0,1-.577-1.185,1.4,1.4,0,0,1,.566-1.193,2.076,2.076,0,0,1,1.274-.379,2.044,2.044,0,0,1,1.281.387,1.424,1.424,0,0,1,.544,1.185A1.4,1.4,0,0,1,468.337,338.606Z"
              transform="translate(-235.852 -330.117)"
              fill="#fff"
            />
            <path
              id="Path_464"
              data-name="Path 464"
              d="M480.211,336.383a2.673,2.673,0,0,0-1.9.754,2.761,2.761,0,0,0-.88,1.858,3.922,3.922,0,0,0,.826,2.211l.271.35.7-.546A3.792,3.792,0,0,1,478.3,339a1.863,1.863,0,0,1,.617-1.238A1.91,1.91,0,0,1,482.111,339a3.781,3.781,0,0,1-.917,2.01l.7.546A4.664,4.664,0,0,0,482.987,339a2.771,2.771,0,0,0-.877-1.858A2.669,2.669,0,0,0,480.211,336.383Z"
              transform="translate(-239.678 -331.635)"
              fill="#fff"
            />
            <path
              id="Path_465"
              data-name="Path 465"
              d="M498.249,334.208v-3.315c.279-.026.419-.17.419-.426,0-.282-.172-.422-.524-.422h-.865l-1.057,2.559-1.068-2.559h-.862c-.349,0-.523.14-.523.422,0,.256.14.4.422.426v3.315c-.327,0-.489.143-.489.426s.174.419.524.419h1.033c.349,0,.522-.14.522-.419a.423.423,0,0,0-.138-.324.552.552,0,0,0-.384-.1h-.284v-2.517l.91,2.179h.685l.893-2.184v2.522h-.284q-.524,0-.524.426t.524.419h1.033q.524,0,.524-.419C498.738,334.351,498.572,334.208,498.249,334.208Z"
              transform="translate(-244.06 -329.929)"
              fill="#fff"
            />
            <path
              id="Path_466"
              data-name="Path 466"
              d="M492.229,330.045h-4.064V331.7c0,.374.132.563.393.563s.393-.189.393-.563v-.808h.848v3.315h-.524q-.524,0-.524.447c0,.267.175.4.524.4h1.839c.349,0,.525-.14.525-.419s-.176-.426-.525-.426h-.531v-3.315h.861v.808c0,.374.133.563.394.563s.391-.189.391-.563Z"
              transform="translate(-242.569 -329.929)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>

      <div class="timeline__scroll-sign">
        <span class="wc white bold-italic f-16">{{ $fn.tr("დასქროლე") }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="46.487"
          height="22.036"
          viewBox="0 0 46.487 22.036"
        >
          <g
            id="Group_506"
            data-name="Group 506"
            transform="translate(34.858 3.372) rotate(90)"
          >
            <g id="menu" transform="translate(0 0)">
              <g
                id="Group_103"
                data-name="Group 103"
                transform="translate(0 0)"
              >
                <path
                  id="Union_6"
                  data-name="Union 6"
                  d="M14.265,18.651a58.664,58.664,0,0,1,7.447-5.2,24.173,24.173,0,0,1,2.613-1.368q-.109-.028-.216-.059a49.245,49.245,0,0,0-8.662.036c-1.76.11-3.5.22-5.166.219-7.136-.007-14.223-.642-21.373-.3-2.462.115-6.585-2.223-2.418-2.421,4.456-.212,8.879-.064,13.3.085,3.621.122,7.242.243,10.884.167,4.948-.1,10.317-.76,15.181.049.094.016.189.032.286.051-2.632-2.721-5.6-5.12-7.845-8.2C17.6.754,18.154-.806,19.107.5c2.79,3.823,6.7,6.609,9.694,10.262.507.618.432,1.5.023,1.653a1.434,1.434,0,0,1-.941.424c-2.147.143-4.13,1.376-5.9,2.52a65.656,65.656,0,0,0-6.131,4.375,1.417,1.417,0,0,1-.9.3C14.115,20.034,13.35,19.406,14.265,18.651Z"
                  transform="translate(-2.37 18.527) rotate(-90)"
                  fill="#bacb32"
                  stroke="#bacb32"
                  stroke-width="2"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <Footer v-if="windowWidth >= 1024" />
  </div>
</template>

<script>
import SmoothScrollTimeline from "@/components/SmoothScrollTimeline";

import PageTitle from "@/components/layout/PageTitle";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
export default {
  components: { SmoothScrollTimeline, Header, PageTitle, Footer },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    zoomedPic() {
      return this.$store.state.main.zoomedPic;
    },
    zoomedCall() {
      return this.$store.state.main.zoomedCall;
    },
    getColors() {
      let cMenu;
      let c = [];
      let locale = this.$store.state.main.locale;
      cMenu = this.$store.state.main.indx.menus.filter(
        menu => menu.id == this.$store.state.main.selected_menu.id
      );

      c.push(_.get(cMenu[0], `titles.${locale}.primaryColor`));
      c.push(_.get(cMenu[0], `titles.${locale}.secondaryColor`));
      return c;
    },

    updateKey() {
      return this.$store.state.main.updateKey;
    },

    updateKey2() {
      return this.$store.state.main.updateKey2;
    }
  },

  methods: {
    onResize() {
      this.windoWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    addCloseClass(e) {
      e.currentTarget
        .querySelector(".green-overlay")
        .classList.remove("zoomed");
      e.currentTarget.querySelector(".z__bg").classList.remove("zoomed");
      e.currentTarget.querySelector(".cl__wrapper").classList.remove("zoomed");
       let zPic = document.querySelector(".zoomed-pic");
        let _l = zPic.getBoundingClientRect().left;
        let _t = zPic.getBoundingClientRect().top;

   
        this.$store.state.main.zoomedPic.left = _l;
        this.$store.state.main.zoomedPic.top = _t;

      document.querySelector(".timeline__wrapper").style.pointerEvents = "none";
      setTimeout(() => {
       
      if(document.querySelector(".center-zoomed")) {
        document.querySelector(
          ".center-zoomed"
        ).style.transform = `translate(0px, 0px) scale(1)`;
      }
    
        
      
      }, 300);
    
      let zoomedPic =  document.querySelector(".zoomed-pic");
      let hiddenTTL = document.querySelector(".hidden-ttl");
      let hiddenP = document.querySelector(".hidden-p");
      let hiddenSticker = document.querySelector(".hide-sticker");
      setTimeout(() => {
        this.$store.state.main.zoomedCall = false;
        let zoomedPic = {
          src: null,
          left: null,
          top: null,
          width: null,
          height: null
        };
        this.$store.state.main.zoomedPic = zoomedPic;
      }, 1010);
      setTimeout(() => {
      zoomedPic.classList.remove("zoomed-pic");
        document.querySelector(".ch-z-index").style.zIndex = "3";
        if (hiddenTTL)
          
          hiddenTTL.style.opacity = "1";
          // hiddenTTL.classList.remove("hidden-ttl");
        if (hiddenP)
          hiddenP.style.opacity = "1";
          // hiddenP.classList.remove("hidden-p");
          if(hiddenSticker) hiddenSticker.classList.remove("hide-sticker")
      }, 1000);
      setTimeout(() => {
        if(hiddenTTL)hiddenTTL.classList.remove("hidden-ttl");
        if(hiddenP)hiddenP.classList.remove("hidden-p");

      }, 1100);
      setTimeout(() => {
      document.querySelector(".timeline__wrapper").style.pointerEvents = "all";
        
      }, 1800);
    }
  },
  watch: {
    zoomedCall(ns, os) {
      if (ns == true) {
        setTimeout(() => {
          let zoomedImg = document.querySelector(".dummy-pic .z__img");
          let cX;
          let scale_val;
          window.innerWidth >= 1024 ? (scale_val = 1.7) : (scale_val = 1.2);
          cX =
            zoomedImg.getBoundingClientRect().left -
            window.innerWidth / 2 +
            zoomedImg.offsetWidth / 2;

          let cY =
            zoomedImg.getBoundingClientRect().top -
            window.innerHeight / 2 +
            zoomedImg.offsetHeight / 2;

          //  cX > 0 ? zoomedImg.style.transform = `translateX(-${cX}px)` : zoomedImg.style.transform = `translateX(${cX}px)`;
          zoomedImg.classList.add("center-zoomed");

          document.querySelector(
            ".center-zoomed"
          ).style.transform = `translate(${cX * -1}px, ${cY *
            -1}px) scale(${scale_val})`;
          // zoomedImg.style.transform = `scale(1.5)`;
          document.querySelector(".green-overlay").classList.add("zoomed");
          document.querySelector(".z__bg").classList.add("zoomed");
          document.querySelector(".cl__wrapper").classList.add("zoomed");
        }, 300);
      }
    },
    $route: {
      immediate: true,
      deep: true,
      handler: function() {
        this.$store.state.main.updateKey += 1;
      },
      handler2: function() {
        this.$store.state.main.updateKey2 += 1;
      }
    }
  }
};
</script>

<style lang="scss">
.dummy-pic {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 9999;
  img {
    position: absolute;
    object-fit: cover;
    transition: all 0.7s cubic-bezier(0.25, 1, 0.5, 1);
    z-index: 90;
  }
  .cl__wrapper{
    display: flex;
    align-items: center;
    transition: .5s;
    cursor: pointer;
    position: absolute;
    top: 21px;
    left: 50%;
    will-change: transform;
    transform: translateX(-50%) scale(0.6) rotate(2deg);
    z-index: 13;
    opacity: 0;
    svg{
      margin-right: 12px;
    }
     &.zoomed{
      transform: translateX(-50%) scale(1) rotate(0deg);
      opacity: 1;
    }
    @media (min-width: 1024px){
      &:hover{
        transform: translateX(-50%) scale(1.1) rotate(-2deg);
      }
    }
   
  }
  .z__bg {
    position: absolute;
    bottom: 27.5px;
    left: 22.53125%;
    transition: all 0.7s cubic-bezier(0.25, 1, 0.5, 1);
    transform: scale(0.7) skew(2deg) rotate(-3deg);
    opacity: 0;
    &.zoomed {
      transform: scale(1) skew(0) rotate(0deg);
      opacity: 1;
    }
    @media (max-width: 1679px) {
      left: 17%;
    }
    @media (max-width: 1365px) {
      left: 12%;
    }
    @media (max-width: 1023px) {
      left: 76.6px;
      bottom: 54.6px;

      transform: scale(0.7) skew(2deg) rotate(-6deg);
      &.zoomed {
        transform: scale(1) skew(1deg) rotate(-3deg);
        opacity: 1;
      }
    }
    @media (max-width: 767px) {
      left: 26.6px;
      bottom: initial;
      top: 214.7px;
      width: 260.27px;
      height: 258.96px;
      transform: scale(0.7) skew(2deg) rotate(-6deg);
      &.zoomed {
        transform: scale(1) skew(1deg) rotate(-3deg);
        opacity: 1;
      }
    }
    @media (max-width: 413px) {
      left: 26.6px;
      bottom: initial;
      top: 274.7px;
      width: 175.45px;
      height: 174.57px;
      transform: scale(0.7) skew(2deg) rotate(-6deg);
      &.zoomed {
        transform: scale(1) skew(1deg) rotate(-3deg);
        opacity: 1;
      }
    }
  }

  .green-overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #044b30;
    opacity: 0;
    transition: all 0.8s;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 12;
    &.zoomed {
      pointer-events: all;
      opacity: 1;
    }
  }

  &.close {
  }
}
.timeline-layout {
  .page-title {
    position: fixed;
    height: 148px;
    h1 {
      color: white;
    }
    @media (max-width: 1023px) {
      position: relative;
      h1 {
        position: absolute;
        top: 148px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    @media (max-width: 767px) {
      h1 {
        top: 138px;
      }
      padding-bottom: 34px;
    }
  }
  .lang-cont a.active,
  .lang-cont a,
  header .header-inner .right-col .profile-info span {
    color: white;
  }

  header .header-inner .right-col .profile-info svg path {
    stroke: white;
  }
  header .header-inner .right-col .cart-icon svg path {
    fill: white;
  }
  header .header-inner .right-col .cart-icon .circle,
  header .header-inner .right-col .burger-icon .green-line,
  header .header-inner .right-col .lang-div .green-line,
  header .header-inner .right-col .cart-icon .green-line {
    background-color: #bacb32;
  }
  header .header-inner .right-col .cart-icon span {
    color: #044b30;
  }
  header .header-inner .right-col .burger-icon .lines-wrapper span {
    background-color: white;
  }
  header .header-inner .right-col .profile-icon svg path {
    fill: white;
  }
  header .header-inner .right-col .profile-info .dropdown span,
  header .header-inner .right-col .profile-info .dropdown a {
    color: #044b30;
  }
  header .header-inner #jujuna-logo {
    path {
      fill: #bacb32;
    }
  }
  footer {
    position: fixed;
    bottom: 0;
    border-top: white 1px solid;
    @media (max-width: 1023px) {
      position: relative;
      bottom: initial;
    }
  }

  .footer-inner {
    transform: translateY(0);
    span,
    a,
    p {
      color: white;
    }
    svg path {
      fill: white;
    }
  }

  .timeline__footer {
    position: fixed;
    bottom: 162px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 405px;
    padding-right: 55px;
    width: 100%;
    @media (max-width: 1679px) and (max-height: 1100px) {
      padding-left: 165px;
    }
    @media (max-width: 1679px) and (max-height: 849px) {
      padding-left: 165px;
    }
        @media (max-width: 1679px) and (max-height: 759px) {
      bottom: 122px;
      svg{
        &:nth-child(1){
          transform: scale(0.7);
        }
      }
    }

    @media (max-width: 1365px) and (min-width: 1024px) and (max-height: 1100px) {
      padding-left: 127px;
    }
    @media (max-width: 1365px) and (min-width: 1024px) and (min-height: 1100px) {
      padding-left: 127px;
    }
    @media (max-width: 1365px) and (min-width: 1024px) and (max-height: 849px) {
      padding-left: 127px;
    }
    @media (max-width: 1023px) {
      transform: rotate(-90deg) translateY(-30px);
      width: fit-content;
      padding-left: 0;
      padding-right: 0;
      bottom: initial;
      top: 874.3px;

      svg {
        &:nth-child(1) {
          display: none;
        }
      }
    }
    @media (max-width: 767px) {
      transform: rotate(-90deg) translateY(-53px);
    }
    @media (max-width: 413px) {
      top: 600px;
    }
  }
  .timeline__scroll-sign {
    display: flex;
    @media (max-width: 1023px) {
      span {
        order: 2;
      }
    }
    @media (max-width: 767px){
      display: none;
    }

    svg {
      margin-left: 13.2px;
      @media (max-width: 1023px) {
        order: 1;
        transform: rotate(180deg);
        margin-right: 22px;
      }
    }
  }
}
</style>
